import { Button, Select } from "@swot/base-components";

export function CmtsSmartDataGridPagination(props: {
  pageIndex: number;
  pageSize: number;
  totalRows: number;
  pageSizeOptions: readonly number[];
  onPrevious: () => void;
  onNext: () => void;
  onPageSizeChange: (size: number) => void;
}) {
  const totalPages = Math.max(1, Math.ceil(props.totalRows / props.pageSize));
  const start = props.totalRows === 0 ? 0 : props.pageIndex * props.pageSize + 1;
  const end = Math.min(props.totalRows, (props.pageIndex + 1) * props.pageSize);
  return (
    <div className="cmts-smart-grid-pagination" aria-label="Table pagination">
      <span className="cmts-smart-grid-range">Showing {start}-{end} of {props.totalRows}</span>
      <div className="cmts-smart-grid-pager-controls">
        <Button label="Previous" variant="secondary" onClick={props.onPrevious} disabled={props.pageIndex <= 0} />
        <span>Page {props.pageIndex + 1} of {totalPages}</span>
        <Select
          label="Rows"
          value={String(props.pageSize)}
          onChange={(event) => props.onPageSizeChange(Number(event.currentTarget.value))}
          options={props.pageSizeOptions.map((size) => ({ value: String(size), label: String(size) }))}
        />
        <Button label="Next" variant="secondary" onClick={props.onNext} disabled={props.pageIndex >= totalPages - 1} />
      </div>
    </div>
  );
}
